/* eslint-disable no-unused-vars */
import React, { Component, forwardRef } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';

const StyledTinBox = styled.div`
  display: block;
  height: 1px;
  margin: 8px auto 24px;
  padding-left: 16px;
  padding-right: 16px;

  div {
    background-color: rgba(0, 0, 0, 0.18);
    width: 100%;
    height: 1px;
  }
`;

/**
 * {@link Inquiry} 区切り線
 * @param {*} props React.props
 * @return {*} React.node - {@link Inquiry} 区切り線
 * @constructor
 */
const FreeHr = props => (
  <StyledTinBox className={'FreeHr'} {...props}>
    <div />
  </StyledTinBox>
);

export default FreeHr;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/body/free/FreeHr.js